(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taneria-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taneria-product-recommendations')) {
    customElements.define('taneria-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true' || !this.dataset.url) return;
        this.dataset.loaded = 'true';

        const loadRecommendations = () => {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('taneria-product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(() => {});
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            loadRecommendations();
          }, { rootMargin: '0px 0px 300px 0px' });
          observer.observe(this);
        } else {
          loadRecommendations();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
